module.exports = __webpack_public_path__ + "img/form-icon.c9a8bd59.svg";